import { useSyncExternalStore } from "react";
import { useCurrentStateAndParams } from "@uirouter/react";

import { customIndustryAgentRunService } from "../../services/customIndustryAgentRun/customIndustryAgentRunService";
import type { CustomIndustryAgentRunSnapshot } from "../../services/customIndustryAgentRun/types";

export const MARKET_BUILDER_STATE = "market_research_builder";

export const shouldShowCustomIndustryAgentBanner = (
    snapshot: CustomIndustryAgentRunSnapshot,
    currentStateName?: string,
    initialLoadComplete = true,
): boolean => {
    if (!initialLoadComplete) {
        return false;
    }

    if (snapshot.status === "idle") {
        return false;
    }

    if (currentStateName === MARKET_BUILDER_STATE) {
        return false;
    }

    return true;
};

export const useCustomIndustryAgentRunSnapshot = (): CustomIndustryAgentRunSnapshot =>
    useSyncExternalStore(customIndustryAgentRunService.subscribe, customIndustryAgentRunService.getSnapshot);

export const useCustomIndustryAgentBannerVisible = (snapshot: CustomIndustryAgentRunSnapshot): boolean => {
    const { state } = useCurrentStateAndParams();
    const initialLoadComplete = useSyncExternalStore(
        customIndustryAgentRunService.subscribe,
        customIndustryAgentRunService.getInitialLoadComplete,
    );

    return shouldShowCustomIndustryAgentBanner(snapshot, state.name, initialLoadComplete);
};
